import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "Web Development",
      desc: "Modern responsive websites for business growth.",
      img: "https://images.pexels.com/photos/574071/pexels-photo-574071.jpeg",
    },
    {
      title: "App Development",
      desc: "Android & iOS apps with smooth performance.",
      img: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
    },
    {
      title: "Digital Marketing",
      desc: "Grow your brand with smart marketing strategies.",
      img: "https://images.pexels.com/photos/905163/pexels-photo-905163.jpeg",
    },
    {
      title: "UI/UX Design",
      desc: "Clean and modern user interface design.",
      img: "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg",
    },
    {
      title: "E-Commerce",
      desc: "Complete online store with payment integration.",
      img: "https://images.pexels.com/photos/230544/pexels-photo-230544.jpeg",
    },
    {
      title: "SEO Optimization",
      desc: "Rank higher on Google and increase traffic.",
      img: "https://images.pexels.com/photos/270348/pexels-photo-270348.jpeg",
    },
  ];

  const createSlug = (text) =>
    text
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");

  const openService = (title) => {
    const slug = createSlug(title);
    navigate(`/service/${slug}`);
  };

  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-28 bg-white overflow-hidden">

      <div
        ref={ref}
        className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-10"
      >
        {services.map((item, i) => (
          <div
            key={i}
            onClick={() => openService(item.title)}
            className={`relative group h-[300px] rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
            }`}
            style={{ transitionDelay: `${i * 120}ms` }}
          >

            <img
              src={item.img}
              alt={item.title}
              className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-125 transition duration-700"
            />
          
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/65 to-black/40"></div>

            <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">

              <div className="p-5 rounded-2xl bg-white/10 backdrop-blur-md border border-white/10">

                <h3 className="text-2xl font-bold">{item.title}</h3>

                <p className="text-sm text-gray-200 mt-2">
                  {item.desc}
                </p>

                <button
                  onClick={(e) => {
                    e.stopPropagation(); 
                    openService(item.title);
                  }}
                  className="mt-4 text-sm font-semibold text-red-300 hover:text-red-400"
                >
                  Explore More →
                </button>

              </div>

            </div>
          </div>
        ))}
      </div>

    </section>
  );
};

export default Services;